import { useApiAuthActions } from '@cretesuite/api-client-auth'

export const useAccessTokenActions = () => {
  const { fetchAccessToken, getAccessToken } = useApiAuthActions()

  return { fetchAccessToken, getAccessToken }
}
